import ReadEvent from '@/views/app/events/read-events.view'
import zoneSelectionView from '@/views/app/zone-selection/zone-selection.view'
import allEvents from '@/views/app/events/all-events.view'
// import eventsByDate from '@/views/app/events/read-event-by-date.view'
// import DefaultGuards from '../../../../guards/default.guards'
import multiguard from 'vue-router-multiguard'

export default [
  {
    path: 'events',
    name: 'events',
    component: allEvents,
    meta: {
      title: 'Eventos',
      colorHeader: '#E64858',
      top: 0,
      position: 'fixed',
      hidden: 'block',
      height: 30
    },
    children: [
      {
        path: 'all-events',
        component: allEvents,
        meta: {
          title: 'Eventos',
          colorHeader: '#E64858',
          top: 0,
          position: 'fixed',
          hidden: 'block',
          height: 30
        }
        // beforeEnter: DefaultGuards.onQuery('events')
      },
      {
        path: ':id',
        name: 'Eventos',
        component: ReadEvent,
        meta: {
          title: 'Eventos',
          colorHeader: '#E64858',
          top: 0,
          position: 'fixed',
          hidden: 'block',
          height: 30
        },
        beforeEnter: multiguard([
          // DefaultGuards.onQuery('events'),
          // DefaultGuards.onQuery('artist'),
          // DefaultGuards.onQuery('eventArtist', {limit: 1000}),
          // DefaultGuards.onQuery('artistCategories', {limit: 1000}),
          // DefaultGuards.onQuery('eventCategories', {limit: 1000}),
          // DefaultGuards.onQuery('presentations'),
          // DefaultGuards.onQuery('venues', {limit: 1000})
        ])
      },
      {
        path: 'zone-selection/:id',
        name: 'Zonas',
        component: zoneSelectionView,
        meta: {
          title: 'Selección de Zona',
          colorHeader: '#E64858',
          top: 0,
          position: 'fixed',
          hidden: 'block',
          height: 30
        }
      }
      /* {
        path: 'by-date/:id',
        name: 'dateEvent',
        component: eventsByDate,
        meta: {
          title: 'Fecha Única',
          colorHeader: '#E64858',
          top: 0,
          position: 'fixed',
          hidden: 'block',
          height: 30
        }
      } */
    ]
  }
]



// WEBPACK FOOTER //
// ./src/router/routes/app/events/read-events.route.js